/*
* 合格证/水洗唛打印html
* */
export function AplipayHtml(data) {
    let html = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html>
<head>
 <style type="text/css">
    div,p,a,span.ul,li{
      margin: 0;
      padding: 0;
    }
    * {
      font-family: SimHei;
      color: #000;
      font-size: 12px;
      word-break: break-all;
      word-wrap: break-word;
    }
    .pdf_page {
      page-break-after: always;
      width: 700px;
      margin: 0 auto;
    }
    .pdf_page:last-child {
      page-break-after: auto;
    }
    .title{
      text-align: center;
      font-size: 24px;
      margin-bottom: 20px;
    }
    .content_name{
      margin-bottom: 20px;
      font-size: 22px;
    }
    .text{
      text-indent: 2em;
      word-break:break-all;
      margin-bottom: 30px;
      font-size: 22px;
      line-height: 50px;
    }
    .list_style{
      line-height: 50px;
      font-size: 22px;
    }
    .time_box{
      float: right;
      line-height: 50px;
      margin-top: 20px;
      text-align: center;
    }
    .time_box_title{
       font-size: 20px;
    }
  </style>
</head>
<body>
     <div class="pdf_page">
  <div class="title">
    支付宝退款申请
  </div>
  <div class="content">
     <p class="content_name">
       ${data.accountName}：
     </p>
    <div class="text">
      我公司通过SGS在线商城订购服务：${data.orderNumber}，将${data.amount}元人民币汇给贵单位。现请贵单位核实后予以原路退还。由此带来的不便敬请谅解！
    </div>
    <div class="list_style">
      TIC订单号：${data.orderNumber}
    </div>
    <div class="list_style">
      实际退款金额：${data.amount}
    </div>
    <div class="list_style">
      退款原因：${data.reason}
    </div>
     <div class="list_style">
      退款申请时间：${data.refundTime}
    </div>
    <div class="list_style">
      支付宝交易号：${data.transactionNumber}
    </div>
     <div class="list_style" >
      实际付款支付宝账号：${data.buyerInfo}
    </div>
     <div class="list_style" style="${data.buyerName ? '':'display:none'}">
      实际付款支付宝账号实名：${data.buyerName}
    </div>
    <div class="time_box">
      <div class="time_box_title">
        申请单位：${data.applicant}
      </div>
      <div class="time_box_title">
         ${data.endTime}
      </div>
    </div>

  </div>
</div>
  </body>
  </html>
  `
    return html
}
